import { render, staticRenderFns } from "./List.vue?vue&type=template&id=635ae50c&scoped=true"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"
import style0 from "./List.vue?vue&type=style&index=0&id=635ae50c&prod&lang=scss"
import style1 from "./List.vue?vue&type=style&index=1&id=635ae50c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635ae50c",
  null
  
)

export default component.exports